<template>
  <div>
   <iframe title="MEDICAMENTOS - Disponibilidad por red Según Estrategia Sanitaria" width="600" height="373.5" 
   src="https://app.powerbi.com/view?r=eyJrIjoiODhiZjdhYTMtYzIwOS00OTRjLTkxY2YtNmUyMzRhOWQyY2JkIiwidCI6IjZjZjkxODMyLWEyZWItNDFjOC1iNjkyLTQ5OTczYzlmNzJiOCIsImMiOjR9" frameborder="0" allowFullScreen="true" style="width:100%;height:800px"></iframe>
  </div>
</template>

<style scoped>
</style>

<script>

export default {
    name: 'Medicamentos',
    mounted () {
    
    }
    }
</script>
